module.exports = __webpack_public_path__ + "img/headerbghome.85291ddb.png";